// extracted by mini-css-extract-plugin
module.exports = {"side-toolbar":"SideToolbar_side-toolbar__dA1Yr","side-toolbar-btn":"SideToolbar_side-toolbar-btn__HTrML"};